import React, {useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import SplashScreen from '../../ui/SplashScreen';
import {setToken, setUser} from '../../../../modules/Auth';
import {appStore, RootState} from '../../../../store/configureStore';
import {pathnames as P} from '../../../enums';
import {logoutChannel} from '../../../utils';

const AdminLogout = () => {
  const currentToken = useSelector((state: RootState) => state.auth.token) as string;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentToken) {
      logoutChannel.postMessage('Logout').catch(console.error);
      appStore.dispatch(setUser(null));
      appStore.dispatch(setToken(''));
    }
    navigate(`${P.LOGIN_AS_ADMIN}${location.search}`);
  }, []);

  return <SplashScreen size={'full'}/>;
};

export default AdminLogout;